module.exports = __webpack_public_path__ + "img/bkpsdm.c5326914.png";